import { DatePipe } from '@angular/common';
import { ViewChild } from '@angular/core';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { CodeTable } from '../../core/model/v2/code-table';
import { EmployerRegistration } from '../../core/models/employer/employer-registration';
import { CommonService } from '../../core/services/v2/common.service';
import { EmployerService } from '../../core/services/v2/employer.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-employer-registration',
  templateUrl: './employer-registration.component.html',
  styleUrls: ['./employer-registration.component.scss']
})
export class EmployerRegistrationComponent implements OnInit {
  showStep2: boolean = false;
  statesCodes: CodeTable;
  employerRegistration: EmployerRegistration;
 

  firstNameFormControl = new FormControl('', [
    Validators.required],
  );

  lastNameFormControl = new FormControl('', [
    Validators.required,
  ]);

  emailFormControl = new FormControl('', [
    Validators.required,
  ]);

  phoneNumberFormControl = new FormControl('', [
    Validators.required,
  ]);
  agencyNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  agencyWebsiteFormControl = new FormControl('', [
    Validators.required,
  ]);
  lineFormControl = new FormControl('', [
    Validators.required,
  ]);
  line2FormControl = new FormControl('', [
    Validators.required,
  ]);
  cityFormControl = new FormControl('', [
    Validators.required,
  ]);
  stateFormControl = new FormControl('', [
    Validators.required,
  ]);
  zipCodeFormControl = new FormControl('', [
    Validators.required,
  ]);
  adminNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  adminWebsiteFormControl = new FormControl('', [
    Validators.required,
  ]);
  employerNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  einNumberFormControl = new FormControl('', [
    Validators.required,
  ]);
  employerWebsiteFormControl = new FormControl('', [
    Validators.required,
  ]);
  empLine1FormControl = new FormControl('', [
    Validators.required,
  ]);
  empLine2FormControl = new FormControl('', [
    Validators.required,
  ]);
  empCityFormControl = new FormControl('', [
    Validators.required,
  ]);
  empStateFormControl = new FormControl('', [
    Validators.required,
  ]);
  empZipCodeFormControl = new FormControl('', [
    Validators.required,
  ]);
  empFirstNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  empLastNameFormControl = new FormControl('', [
    Validators.required,
  ]);
  empTitleFormControl = new FormControl('', [
    Validators.required,
  ]);
  empPhoneFormControl = new FormControl('', [
    Validators.required,
  ]);
  empEmailFormControl = new FormControl('', [
    Validators.required,
  ]);
  dataForm: FormGroup = new FormGroup({
    firstName: this.firstNameFormControl,
    lastName: this.lastNameFormControl,
    email: this.emailFormControl,
    phone: this.phoneNumberFormControl,
    agencyName: this.agencyNameFormControl,
    agencyWebsite: this.agencyWebsiteFormControl,
    line: this.lineFormControl,
    line2: this.line2FormControl,
    city: this.cityFormControl,
    state: this.stateFormControl,
    zipcode: this.zipCodeFormControl,
    adminName: this.adminNameFormControl,
    adminWebsite: this.adminWebsiteFormControl,
    employerName: this.employerNameFormControl,
    einNumber: this.einNumberFormControl,
    employerWebsite: this.employerWebsiteFormControl,
    empLine1: this.empLine1FormControl,
    empLine2: this.empLine2FormControl,
    empCity: this.empCityFormControl,
    empState: this.empStateFormControl,
    empZipCode: this.empZipCodeFormControl,
    empFirstName: this.empFirstNameFormControl,
    empLastName: this.empLastNameFormControl,
    empTitle: this.empTitleFormControl,
    empPhone: this.empPhoneFormControl,
    empEmail: this.empEmailFormControl,
  });

  constructor(private _snackBar: MatSnackBar, private loaderService: WindowLoaderService,
    private fb: FormBuilder,
    private el: ElementRef, private commonService: CommonService, private employerService: EmployerService,
    private datePipe: DatePipe, private router: Router  ) { }

  ngOnInit() {
    this.commonService.GetStatesWithoutCache().subscribe(
      codeTables => { this.statesCodes = codeTables.codeTable[0]; },
      error => console.log(error)
    );
  }

  nextStep() {
    this.showStep2 = true;
  }
  previousStep() {
    this.showStep2 = false;
  }

  onSubmit(event: EmployerRegistration): void {
    const formObj = this.dataForm.getRawValue();
    const validate = this.validateForm(this.dataForm);
    if (!validate) {
      return;
    }
    this.saveRegistrationData(formObj); 
  }
  validateForm(addedForm: FormGroup) {
    const validationMessages = {
      'agencyName': 'Agency Name is required.',
      'agencyWebsite': 'Agency Website is required.',
      'adminName': 'Admin Name is required.',
      'adminWebsite': 'Admin Website Name is required.',
      'einNumber': 'EIN Number is required.',
      'empCity': 'Employer City Name is required.',
      'empEmail': 'Employer Email is required.',
      'empFirstName': 'Employer First Name is required.',
      'empLastName': 'Employer Last Name is required.',
      'empLine1': 'Employer Address Line1 is required.',
      'empPhone': 'Employer Phone is required.',
      'empState': 'Employer State is required.',
      'empTitle': 'Employer Title is required.',
      'empZipCode': 'Employer ZipCode is required.',
      'employerWebsite': 'Employer Website is required.',
    };
    const formControls = addedForm.controls;
    const invalidControls = [];
    for (const name in formControls) {
      if (formControls[name].invalid) {
        invalidControls.push(name);
      }
    }
    if (invalidControls.length > 0) {
      const controlName = invalidControls[0];
      this._snackBar.open(validationMessages[controlName], 'Ok', { duration: 5 * 1000 });
      const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + controlName + '"]');
      if (invalidControl.nodeName == 'APP-DYNAMIC-AUTOCOMPLETE') {
        invalidControl.childNodes[0].focus();
      }
      else {
        invalidControl.focus();
      }
      return false;
    }
    else {
      return true;
    }
  }
  saveRegistrationData(formObj: any) {
    if (!formObj) {
      this._snackBar.open('Data can not be saved.', 'Ok', { duration: 5 * 1000 });
    }
    let currentDate = new Date()
    let strCurrentDate = this.datePipe.transform(currentDate, "yyyy-MM-dd hh:mm:ss")
    const employerRegistrationData: EmployerRegistration = {
      id: formObj.id,
      adminName: formObj.adminName,
      adminWebsite: formObj.adminWebsite,
      employerName: formObj.employerName,
      einNumber: formObj.einNumber,
      employerWebsite: formObj.employerWebsite,
      employerLine: formObj.empLine1,
      employerLine2: formObj.empLine2,
      employerCity: formObj.empCity,
      employerState: formObj.empState,
      employerZipCode: formObj.empZipCode,
      employerFirstName: formObj.empFirstName,
      employerLastName: formObj.empLastName,
      employerTitle: formObj.empTitle,
      employerPhone: formObj.empPhone,
      employerEmail: formObj.empEmail,
      isActive: false,
      isApproved: false,
      approvedBy: 0,
      createdOn: strCurrentDate
    };
    this.loaderService.blockWithLoader(this.employerService.AddEmployerRegistrationRequest(employerRegistrationData)).subscribe(
      (details) => {
        if (details.isSuccess) {
          document.getElementById("openRegistrationSuccess").click();
          this.resetForm();
          
        }
        else {
          this._snackBar.open('Duplicate EIN found.', 'Ok', { duration: 5 * 1000 });
        }
      },
      (error) => { console.error(error); }
    );
  }

  resetForm() {
    this.firstNameFormControl.setValue("");
    this.lastNameFormControl.setValue("");
    this.emailFormControl.setValue("");
    this.phoneNumberFormControl.setValue("");
    this.agencyNameFormControl.setValue("");
    this.agencyWebsiteFormControl.setValue("");
    this.lineFormControl.setValue("");
    this.line2FormControl.setValue("");
    this.cityFormControl.setValue("");
    this.stateFormControl.setValue("");
    this.zipCodeFormControl.setValue("");
    this.adminNameFormControl.setValue("");
    this.adminWebsiteFormControl.setValue("");
    this.employerNameFormControl.setValue("");
    this.einNumberFormControl.setValue("");
    this.employerWebsiteFormControl.setValue("");
    this.empLine1FormControl.setValue("");
    this.empLine2FormControl.setValue("");
    this.empCityFormControl.setValue("");
    this.empStateFormControl.setValue("");
    this.empZipCodeFormControl.setValue("");
    this.empFirstNameFormControl.setValue("");
    this.empLastNameFormControl.setValue("");
    this.empTitleFormControl.setValue("");
    this.empPhoneFormControl.setValue("");
    this.empEmailFormControl.setValue("");
    this.previousStep();
  }
  closeNotification() {
    this.router.navigate(['/home']);
  }
}
